'use strict';
'use es6';

/**
 * Creates a function that always returns `returnValue`.
 *
 * @example
 * const alwaysBlue = always('blue');
 * alwaysBlue() === 'blue';
 *
 * @param  {T} returnValue
 * @return {T}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = always;
function always(returnValue) {
  return function () {
    return returnValue;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/always.js
// module id = 685
// module chunks = 2 3